/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bubble_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bubble Chart Maker (Free, Online) — Toolverse`)
};

const es_bubble_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creador de Gráficos de Burbujas (Gratis, Online) — Toolverse`)
};

const de_bubble_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blasendiagramm-Ersteller (Kostenlos, Online) — Toolverse`)
};

const nl_bubble_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bellendiagrammaker (gratis, online) — Toolverse`)
};

const fr_bubble_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créateur de graphique à bulles (gratuit, en ligne) — Toolverse`)
};

const it_bubble_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creatore di grafici a bolle (gratuito, online) — Toolverse`)
};

const pt_br2_bubble_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de Gráfico de Bolhas (Grátis, Online) — Toolverse`)
};

const pt_bubble_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criador de Gráficos de Bolhas (Grátis, Online) — Toolverse`)
};

const ja_bubble_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バブルチャート作成ツール（無料・オンライン） — Toolverse`)
};

const zh_bubble_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`气泡图制作工具（免费在线）— Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bubble_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bubble_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bubble_meta_title", locale)
	if (locale === "en") return en_bubble_meta_title(inputs)
	if (locale === "es") return es_bubble_meta_title(inputs)
	if (locale === "de") return de_bubble_meta_title(inputs)
	if (locale === "nl") return nl_bubble_meta_title(inputs)
	if (locale === "fr") return fr_bubble_meta_title(inputs)
	if (locale === "it") return it_bubble_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_bubble_meta_title(inputs)
	if (locale === "pt") return pt_bubble_meta_title(inputs)
	if (locale === "ja") return ja_bubble_meta_title(inputs)
	return zh_bubble_meta_title(inputs)
};